import React from 'react'
/**
 * A widget to show all contacts related to another contact
 * Either from the database or a form
 * with links to their contact record
 *
 */
class RelatedContacts extends React.Component {

  render() {
    // We use either the entity type (CHILD, PARENT1) if it is a form contact or the guid if its a database contact as the key  for this hash
    const id = this.props.match['id'] === 0 ? this.props.entity : this.props.match['id'];
    const formContact = id === this.props.entity && !this.props.entity.includes('HOUSEHOLD')
    const relatedContacts = this.props.relatedContacts ;
    return (
      <div className="form-import-related-contacts">
        <div className="form-import-subheader"> {this.props.entity.includes('HOUSEHOLD') ? <h3>Household Contacts</h3> : <h3>Related Contacts</h3>} </div>
        { Object.keys(relatedContacts[id]).map(function(key) {
              return (<div className="form-import-related-contact">
                { formContact ?  relatedContacts[id][key][1] :  <a href={"contacts/" + relatedContacts[id][key][1]} target="blank"> {relatedContacts[id][key][0]}</a> }
                </div>)
        })}
      </div>
    )
  }
}

export default RelatedContacts;
